<template>
  <div class="wrapper">
    <div class="animated fadeIn">
      <create-reporttypeforeigners></create-reporttypeforeigners>
    </div>
  </div>
</template>

<script>
import CreateReporttypeforeigners from "../../components/CreateReporttypeforeigners.vue";

export default {
  components: {
    CreateReporttypeforeigners
  },
  name: "Reporttypeforeigners",
  data() {
    return {
      items: [],
      categorey: []
    };
  },
  methods: {},
  mounted() {},
  created() {}
};
</script>
<style></style>
